// tslint:disable-next-line: no-submodule-imports
import useStyles from 'isomorphic-style-loader/useStyles';
import React from 'react';
import Helmet from 'react-helmet';
import { useSelector } from 'react-redux';
import ContextMenuOverlay from '../components/ContextMenuOverlay';
import { SplashScreen } from '../components/SplashScreen';
import Tooltip from "../components/Tooltip";
import Transport from '../components/Transport';
import Template from '../Contexts/Template';
import { DIALOG_TEMPLATE } from '../types/templates/dialog';
import { NOW_PLAYING_TEMPLATE } from '../types/templates/nowPlaying';
import MultiSelectBar from './MultiSelectBar';
import * as Styles from './TemplateContainer.scss';
import View from './View';
export default function TemplateContainer() {
    useStyles(Styles);
    const { currentTemplate, overlayTemplates } = useSelector((state) => state.TemplateStack);
    const { displayLanguageId } = useSelector((state) => state.Authentication);
    const { preventUserSelect } = useSelector((state) => state.InteractionState);
    const { isTransportOverlayOpen } = useSelector((state) => state.TransportOverlay);
    const hasOverlay = overlayTemplates.length > 0;
    const isNPVShowing = hasOverlay &&
        !!overlayTemplates.find(template => template.interface === NOW_PLAYING_TEMPLATE);
    const isDialogShowing = hasOverlay &&
        !!overlayTemplates.find(template => template.interface === DIALOG_TEMPLATE);
    const backgroundClass = isNPVShowing ? Styles.hidden : hasOverlay ? Styles.blurContent : '';
    const viewContainerClass = [backgroundClass, Styles.viewContainer].join(' ');
    return (React.createElement("music-app", { class: ['hydrated', preventUserSelect ? Styles.selectDisabled : null].join(' ') },
        React.createElement(Template.Provider, { value: currentTemplate },
            currentTemplate && getSEOHead(currentTemplate, displayLanguageId),
            React.createElement("div", null, hasOverlay && React.createElement(View, { template: overlayTemplates[0] })),
            React.createElement("div", { className: viewContainerClass }, currentTemplate ? React.createElement(View, { template: currentTemplate }) : React.createElement(SplashScreen, null)),
            React.createElement(Tooltip, { isNowPlaying: isNPVShowing, template: currentTemplate }),
            React.createElement(Transport, { isNowPlaying: isNPVShowing, isDialogShowing: isDialogShowing, isTransportOverlayOpen: isTransportOverlayOpen }),
            !hasOverlay ? React.createElement(MultiSelectBar, null) : null,
            React.createElement(ContextMenuOverlay, null))));
}
// https://stackoverflow.com/questions/25421233/javascript-removing-undefined-fields-from-an-object
function removeUndefined(obj) {
    Object.keys(obj).forEach(key => (obj[key] === undefined || obj[key] === null) && delete obj[key]);
    return obj;
}
function getSEOHead(template, displayLanguageId) {
    var _a, _b, _c, _d, _e;
    const seoHead = ((_c = (_b = (_a = template) === null || _a === void 0 ? void 0 : _a.innerTemplate) === null || _b === void 0 ? void 0 : _b.templateData) === null || _c === void 0 ? void 0 : _c.seoHead) || ((_e = (_d = template) === null || _d === void 0 ? void 0 : _d.templateData) === null || _e === void 0 ? void 0 : _e.seoHead);
    if (seoHead) {
        // Remove interface and null fields from objects in script, meta, and link arrays
        const scripts = seoHead.script.map(({ innerHTML }) => removeUndefined({ innerHTML, type: 'application/ld+json' }));
        const metas = seoHead.meta.map(({ name, property, content }) => removeUndefined({ name, property, content }));
        const links = seoHead.link.map(({ rel, href, hreflang }) => removeUndefined({ rel, href, hreflang }));
        return (React.createElement(Helmet, { title: seoHead.title, meta: metas, link: links, script: scripts, lang: displayLanguageId }));
    }
}
